import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=e794d52a&scoped=true&"
import script from "./TextList.vue?vue&type=script&lang=js&"
export * from "./TextList.vue?vue&type=script&lang=js&"
import style0 from "./TextList.vue?vue&type=style&index=0&id=e794d52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e794d52a",
  null
  
)

export default component.exports